import React, { useMemo } from "react";
import "../../OperationsJournal.css";

const getVisiblePages = (current, total) => {
  if (total <= 7) {
    return Array.from({ length: total }, (_, i) => i + 1);
  }
  if (current <= 3) {
    return [1, 2, 3, "ellipsis", total];
  }
  if (current >= total - 2) {
    return [1, "ellipsis", total - 2, total - 1, total];
  }
  return [1, "ellipsis", current - 1, current, current + 1, "ellipsis", total];
};

/** Подвал таблицы журнала: «Показано: N из M» и постраничная навигация */
function JournalPagination({ page, totalPages, shown, total, onChange }) {
  const visiblePages = useMemo(
    () => getVisiblePages(page, totalPages),
    [page, totalPages]
  );

  return (
    <div className="oj-footer">
      <div className="oj-footer__count">
        Показано: {shown} из {total}
      </div>
      <div className="oj-pagination">
        <button
          type="button"
          className="oj-pagination__btn"
          disabled={page === 1}
          onClick={() => onChange(1)}
          aria-label="Первая страница"
        >
          «
        </button>
        <button
          type="button"
          className="oj-pagination__btn"
          disabled={page === 1}
          onClick={() => onChange(Math.max(1, page - 1))}
          aria-label="Предыдущая страница"
        >
          ‹
        </button>
        {visiblePages.map((item, idx) =>
          item === "ellipsis" ? (
            <span key={`ellipsis-${idx}`} className="oj-pagination__ellipsis">
              …
            </span>
          ) : (
            <button
              key={item}
              type="button"
              className={`oj-pagination__btn${item === page ? " is-active" : ""}`}
              onClick={() => onChange(item)}
            >
              {item}
            </button>
          )
        )}
        <button
          type="button"
          className="oj-pagination__btn"
          disabled={page === totalPages}
          onClick={() => onChange(Math.min(totalPages, page + 1))}
          aria-label="Следующая страница"
        >
          ›
        </button>
        <button
          type="button"
          className="oj-pagination__btn"
          disabled={page === totalPages}
          onClick={() => onChange(totalPages)}
          aria-label="Последняя страница"
        >
          »
        </button>
      </div>
    </div>
  );
}

export default JournalPagination;
